export default __webpack_public_path__ + "6c2095ff1831df36fe7f27ffce4397c47078d0cc8beb274319a58de58405251a.png";